import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import {
  ReturnTagSource,
  TagKind,
  TagSchema,
} from "@redotech/redo-common-model-tags-common/tag";
import { PillTheme } from "@redotech/redo-storefront-common/pill-theme";
import * as z from "zod";
import { canAddTagToReturn } from "../../returns/return-action-eligibility";
import { defineReturnAction } from "../types";

const BulkAddTagPayloadSchema_ = z.object({ tag: TagSchema });
export interface AddTagPayload extends z.infer<
  typeof BulkAddTagPayloadSchema_
> {}

export const addTagReturnAction = defineReturnAction<AddTagPayload>({
  label: "Add tag",
  permissions: [ReturnsAndClaimsPermissions.EDIT_RETURN_INFORMATION],
  isEligible: ({ return_ }) => canAddTagToReturn({ return_ }),
  payloadSchema: BulkAddTagPayloadSchema_,
  examplePayload: {
    tag: {
      name: "Needs inspection",
      pillTheme: PillTheme.NORMAL,
      source: ReturnTagSource.MERCHANT,
      kind: TagKind.RETURN,
    },
  },
});
